type Id = string | number | null | undefined;
export const PayrunAPIV2 = {
  payruns: 'api/v2/payruns',
  payrunById: (id?: Id) => `api/v2/payruns/${id}`,
  payrunApprovers: (companyId: Id) => `api/v2/companies/${companyId}/payrunapprovers`,
  payrunApproversDetails: (companyId: Id, userId: Id) =>
    `api/v2/companies/${companyId}/payrunapprovers/${userId}`,
  /**@deprecated use skipPayRunsV2 instead */
  skipPayRuns: '/<%userArea%>/payruns/skippayruns',
  skipPayRunsV2: 'api/v2/payruns/skippayruns',
  rejectEarningLinesByPayrunId: (id: Id) => `api/v2/payruns/${id}/reject`,
  preparePayrun: (id?: Id) => `api/v2/payruns/${id}/prepare`,
  updateAssignee: (id?: Id) => `/api/v2/payruns/${id}/assignee`,
  assigneeHistory: (id?: Id) => `/api/v2/payruns/${id}/assigneeHistory`,
  externalPayruns: (id?: Id) => `/api/v2/payruns/${id}/externalPayruns`,
  updatePayrunMilestones: '/api/v2/payruns/updatePayrunMilestones',
  finalisePayrun: (id?: Id) => `/api/v2/payruns/${id}/finalise`,
} as const;
